import { render } from "./discountActivationCheckbox.vue?vue&type=template&id=61fac5a3"
import script from "./discountActivationCheckbox.vue?vue&type=script&lang=js"
export * from "./discountActivationCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__